import { useState, useEffect } from 'react';
import { ThemeProvider } from './context/ThemeContext';

import Navbar        from './components/Navbar';
import Footer        from './components/Footer';
import LeadFormModal from './components/LeadFormModal';

import Home      from './pages/Home';
import Services  from './pages/Services';
import Portfolio from './pages/Portfolio';
import About     from './pages/About';
import Pricing   from './pages/Pricing';
import Blog      from './pages/Blog';
import Contact   from './pages/Contact';
import Privacy   from './pages/Privacy';

const PAGES = {
  home:      Home,
  services:  Services,
  portfolio: Portfolio,
  about:     About,
  pricing:   Pricing,
  blog:      Blog,
  contact:   Contact,
  privacy:   Privacy,
};

export default function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [showForm,    setShowForm]    = useState(false);
  const [visible,     setVisible]     = useState(true);

  const navigate = (page) => {
    setVisible(false);
    setTimeout(() => {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setVisible(true);
    }, 220);
  };

  // Scroll-triggered popup after 30 seconds on page
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!showForm) setShowForm(true);
    }, 30000);
    return () => clearTimeout(timer);
  }, [currentPage]);

  const openForm  = () => setShowForm(true);
  const closeForm = () => setShowForm(false);

  const PageComponent = PAGES[currentPage] || Home;

  return (
    <ThemeProvider>
      <Navbar
        currentPage={currentPage}
        navigate={navigate}
        openForm={openForm}
      />

      <main style={{
        opacity:    visible ? 1 : 0,
        transform:  visible ? 'translateY(0)' : 'translateY(12px)',
        transition: 'opacity 0.35s ease, transform 0.35s ease',
      }}>
        <PageComponent navigate={navigate} openForm={openForm} />
      </main>

      <Footer navigate={navigate} />

      {showForm && <LeadFormModal onClose={closeForm} />}
    </ThemeProvider>
  );
}
